import { createEntity } from "utils/entities";
import { TemplateSchema } from "utils/schemas";

export const initialState = {
  details: {
    currentTemplateGuid: null,
    areProfilesLoading: false,
    isDetailsLoading: true,
    isVariablesLoading: true,
    variablesGuids: [],
    selectedVariables: [],
  },
  configuration: {
    draftMaintenancePolicyGuid: null,
    isEditTemplate: false,
    selectedMaintenancePolicyGuid: null,
    selectedProfileGuids: [],
  },
};

export function UPDATE_ROUTER_PARAMS(nextState, { params }) {
  const temporaryTemplate = createEntity(
    {
      metadata: { uid: params.id },
      spec: { profiles: [], policies: [] },
    },
    TemplateSchema
  );
  nextState.details.currentTemplateGuid = temporaryTemplate.guid;
}

export function FETCH_TEMPLATE_DETAILS_REQUEST(nextState) {
  nextState.details.isDetailsLoading = true;
  nextState.details.isVariablesLoading = true;
  nextState.details.selectedVariables = [];
}

export function FETCH_PROFILES_DETAILS_REQUEST(nextState) {
  nextState.details.areProfilesLoading = true;
}

export function FETCH_PROFILES_DETAILS_SUCCESS(nextState) {
  nextState.details.areProfilesLoading = false;
}

export function FETCH_TEMPLATE_DETAILS_SUCCESS(nextState, { result }) {
  nextState.details.currentTemplateGuid = result.guid;
  nextState.details.isDetailsLoading = false;
}

export function SET_SELECTED_MAINTENANCE_POLICY_GUID(nextState, { guid }) {
  nextState.configuration.selectedMaintenancePolicyGuid = guid;
}

export function SET_INITIAL_SELECTED_MAINTENANCE_POLICY_GUID(
  nextState,
  { guid }
) {
  nextState.configuration.draftMaintenancePolicyGuid = guid;
}

export function EDIT_TEMPLATE(nextState, { isEditTemplate }) {
  nextState.configuration.isEditTemplate = isEditTemplate;
}

export function SET_SELECTED_PROFILES(
  nextState,
  { selectedProfileGuids = [] }
) {
  nextState.configuration.selectedProfileGuids = selectedProfileGuids;
}

export function FETCH_VARIABLES_VALUES_SUCCESS(nextState, { result }) {
  nextState.details.isVariablesLoading = false;
  const guids = result.flatMap(({ status, value }) => {
    if (status !== "fulfilled") {
      return [];
    }
    return value.map((val) => val.guid);
  });
  nextState.details.variablesGuids = guids;
}

export function SET_SELECTED_VARIABLES(nextState, { selectedVariables = [] }) {
  nextState.details.selectedVariables = selectedVariables;
}
